interface ISvgPlantProps {
    height: number | string;
    width: number | string;
    color: string;
}

const SvgPlant: React.FC<ISvgPlantProps> = (props) => {
    return (
        <svg width={props.width} height={props.height} viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.8439 15.0938C6.7252 20.2125 6.7252 28.5375 11.8439 33.6563C14.4127 36.225 17.7689 37.5 21.1252 37.5C24.4814 37.5 27.8377 36.225 30.4064 33.6563C36.9314 27.1313 38.0002 7.5 38.0002 7.5C38.0002 7.5 18.3689 8.56875 11.8439 15.0938ZM27.7627 31.0125C25.9814 32.775 23.6377 33.75 21.1252 33.75C19.4564 33.75 17.8814 33.2812 16.4752 32.475C18.2002 27.075 21.3877 22.3313 25.6252 18.75C20.6939 21.3 16.5502 25.2375 13.6814 30C10.9064 26.325 11.1502 21.0938 14.5064 17.7375C17.7689 14.475 26.8252 12.4687 33.8752 11.625C33.0314 18.675 31.0252 27.7313 27.7627 31.0125Z"
                fill={props.color}
            />
        </svg>
    );
};

export default SvgPlant;
